if (!customElements.get('nextbottle-sticky')) {
  customElements.define('nextbottle-sticky', class extends HTMLElement {
    connectedCallback() {
      this.box = this.previousElementSibling;
      if (!this.box?.matches('nextbottle-buybox')) return;
      this.submitButton = this.querySelector('[data-nb-sticky-submit]');
      this.onSubmit = () => {
        const form = this.box.querySelector('form');
        const submit = form?.querySelector('[type="submit"]');
        const id = form?.querySelector('[name="id"]');
        if (!form || !submit || submit.disabled || !id?.value || id.disabled || this.box.querySelector('[aria-busy="true"]')) return;
        form.requestSubmit(submit);
      };
      this.submitButton.addEventListener('click', this.onSubmit);
      this.update = () => {
        const state = this.box.querySelector('[data-nb-offer-state]');
        const submit = state?.querySelector('[type="submit"]');
        const pending = !!this.box.querySelector('[aria-busy="true"]');
        this.submitButton.disabled = pending || !submit || submit.disabled;
        this.submitButton.textContent = pending ? 'Wird geprüft …' : submit?.textContent.trim() || 'Nicht verfügbar';
        this.querySelector('[data-nb-sticky-price]').textContent = pending ? '' : state?.querySelector('[data-nb-price] strong')?.textContent.trim() || '';
        const offer = this.box.querySelector('[data-nb-offer][aria-current="true"]');
        const colors = Array.from(state?.querySelectorAll('[data-nb-option]:checked') || [], input => input.closest('label').querySelector('span:last-child')?.childNodes[0]?.textContent.trim() || '');
        this.querySelector('[data-nb-sticky-selection]').textContent = `${offer?.dataset.nbCount || 1} × · ${colors.join(' / ')}`;
      };
      this.mutations = new MutationObserver(this.update);
      this.mutations.observe(this.box, {subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['disabled','aria-busy','aria-current','checked']});
      this.visibility = new IntersectionObserver(entries => {
        this.hidden = entries[0].isIntersecting || entries[0].boundingClientRect.bottom > 0;
      });
      this.visibility.observe(this.box);
      this.update();
    }
    disconnectedCallback() {
      this.mutations?.disconnect();
      this.visibility?.disconnect();
      this.submitButton?.removeEventListener('click', this.onSubmit);
    }
  });
}
